"use client";

import { useContext } from "react";
import useMediaQuery from "@/hooks/useMediaQuery";
import { useGetDisclaimer } from "./hooks/useGetDisclaimer";
import { GlobalContext } from "@/contexts/SiteDataContext";
import { useFooterType } from "@/components/organisms/Footer/useFooterType";
import "./styles.scss";

type UseViewModelOptions = {
  hideContactInfo?: boolean;
};

export const useViewModel = ({ hideContactInfo = false }: UseViewModelOptions = {}) => {
  const { t, siteData, siteDataComplete } = useContext(GlobalContext).context;
  const isFormGeniusCompany = !!(siteData.extraInfo?.key === "fogell");
  const showSiteAddress = siteDataComplete?.showSiteAddress;

  const type = useFooterType().disclaimer;
  const { disclaimer } = useGetDisclaimer(type);
  const isMobile = useMediaQuery("mobile");

  return {
    showContactInfo: !!siteData.hasPhone && !hideContactInfo,
    showSiliconValleyLogo: isFormGeniusCompany,
    showSiteAddress: !!showSiteAddress && !!siteDataComplete?.footer_site_address_text,
    isFormGeniusCompany,
    isMobile,
    disclaimer,
    t,
    contactPhoneNumber: siteData.phoneNumber || "",
    siteAddress: siteDataComplete?.footer_site_address_text,
  };
};
